import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule, MatDialogModule, MatIconModule, MatProgressSpinnerModule } from '@angular/material';
import { TranslateModule } from '@ngx-translate/core';
import { AutoRenewService } from './auto-renew.service';
import { AutoRenewConfirmationDialogComponent } from './dialogs/auto-renew-confirmtion/auto-renew-confirmation.dialog';
import { CancelationInProgressDialogComponent } from './dialogs/cancellation-in-progress/cancellation-in-progress.dialog';
import { CancellationRequestDialogComponent } from './dialogs/cancellation-request/cancellation-request.dialog';
import { ShellDialogComponent } from './dialogs/shell.dialog';


@NgModule({
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    TranslateModule,
    MatIconModule
  ],
  exports: [],
  declarations: [
    CancellationRequestDialogComponent,
    CancelationInProgressDialogComponent,
    AutoRenewConfirmationDialogComponent,
    ShellDialogComponent
  ],
  entryComponents: [
    CancellationRequestDialogComponent,
    CancelationInProgressDialogComponent,
    AutoRenewConfirmationDialogComponent
  ],
  providers: [AutoRenewService],
})
export class AutoRenewModule { }
